module.exports = __webpack_public_path__ + "0aac1ae76991f01959a8d0561ddeb2de.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/max-goodman.jpg
 ** module id = 421
 ** module chunks = 0
 **/